import { AutocompleteRenderGetTagProps, Box } from '@mui/material'
import { C1Chip } from 'c1ui/components/C1Chip/C1Chip'
import { C1Tooltip } from 'c1ui/components/C1Tooltip/C1Tooltip'
import { DetailedHTMLProps } from 'react'

export type Searchable = { id: string; displayName?: string, appId?: string; }
export type { C1AutocompleteSingleAsyncProps } from './C1AutocompleteSingleAsync'

type P = DetailedHTMLProps<React.LiHTMLAttributes<HTMLLIElement>, HTMLLIElement>
export const defaultRenderOption = <T extends Searchable>(props: P, option: T): React.ReactElement => <li {...props} key={`${props.key}-${option.id}-${option.appId}`}>
    {option.displayName}
</li>

export const defaultIsEqual = <T extends Searchable>(a: T, b: T): boolean => a.id === b.id && a.appId === b.appId
export const defaultRenderLabel = <T extends Searchable>(a: T): string => a.displayName || ''

export const defaultRenderTags = <T extends Searchable>(
    value: T[],
    getTagProps: AutocompleteRenderGetTagProps,
): React.ReactElement[] => value.map((option, index) => {
        const { key, ...rest } = getTagProps({ index })
        return <C1Chip key={key} color="primary" label={option.displayName || ''} data-dd-action-name="Remove selection" {...rest} />
    })

export const renderTagsWithLocked = <T extends Searchable>(lockedValues: string[], lockedTooltip?: string): (
    values: T[],
    getTagProps: AutocompleteRenderGetTagProps,
) => React.ReactElement[] => (
        values: T[],
        getTagProps: AutocompleteRenderGetTagProps,
    ): React.ReactElement[] =>
        values.map((option, index) => {
            const { key, ...rest } = getTagProps({ index })
            const isLocked = lockedValues.includes(option.id)
            const chip = <C1Chip
                color={isLocked ? 'info' : 'primary'}
                label={option.displayName || ''}
                data-dd-action-name="Remove selection"
                {...rest}
                onDelete={isLocked ? undefined : rest.onDelete}
            />
            return (
                <C1Tooltip key={key} title={isLocked ? lockedTooltip : ''}>
                    <Box component="span">{chip}</Box>
                </C1Tooltip>
            )
        })

export { C1AutocompleteSingleAsync, C1AutocompleteSingleAsyncHook, type SingleSelectionModalProps } from './C1AutocompleteSingleAsync'
export { C1AutocompleteMultipleAsyncHook, type SelectionsModalProps } from './C1AutocompleteMultipleAsync'
